import { useCallback, useContext, useEffect, useState } from "react"
import { SamplesContext } from "../../../context/samplesContext"
import { useNavigate } from "react-router-dom"
import { PATH_INFO } from "../../utils/helper"
import { BlackButton } from "../../../components/buttons/BlackButton"
import paperIcon from '../../../assets/images/icons/paper-white.svg'
import importIcon from '../../../assets/images/icons/import.svg'
import downloadIcon from '../../../assets/images/icons/download.svg'
import ecImageDownloadIcon from '../../../assets/images/icons/t-shirt-down-arrow.svg'
import pastMeasurementIcon from '../../../assets/images/icons/paper-plus.svg'
import { DESKTOP_XMD_BREAKPOINT_PX, MEDIA_QUERY_MAX_DESKTOP_XMD } from "../../../constants/breakpoints" // Tailwindのdesktop-xmdと同期させるためconstantsで管理している値を使用
import { UserContext } from "../../../context/userContext"

export function ActionButtonsPanel() {
  const { rowSample, canvasImage } = useContext(SamplesContext)
  const { isAuth } = useContext(UserContext)

  const [isSmall, setIsSmall] = useState(false)

  const navigate = useNavigate()

  const downloadPdf = useCallback(async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/client/export/measurement-report`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        body: JSON.stringify({ sample_id: rowSample.id, url: rowSample.url, sampleImage: canvasImage })
      })
      if (res.status === 401 || res.status === 403) {
        sessionStorage.removeItem('token')
        navigate(PATH_INFO.LOGIN.PATH)
      }

      if (res.ok) {
        const blob = await res.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.href = downloadUrl

        a.download = 'measurement_report.pdf'

        a.click()
        a.remove()
        window.URL.revokeObjectURL(downloadUrl)
      }
    } catch (error) {
      console.error("Error PDF download.");
    }
  }, [navigate, rowSample, canvasImage])

  // desktop-xmd未満(タブレットレイアウト時)にボタンの文言を変更(ダウンロード → Download)
  useEffect(() => {
    const media = window.matchMedia(MEDIA_QUERY_MAX_DESKTOP_XMD) // desktop-xmd未満（tailwind.config.jsの値と同じ）
    const listener = () => setIsSmall(media.matches)

    listener()
    media.addEventListener('change', listener)

    return () => media.removeEventListener('change', listener)
  }, [])

  return (
    <div className="text-white space-y-[5px] desktop-xmd:mt-[25px] desktop-xmd:space-y-[10px]">
      <div className="flex space-x-[5px] desktop-xmd:space-x-[9px]">
        <BlackButton
          label="過去の採寸を表示"
          subLabelParts={["表示中の採寸の", "過去の採寸表を表示"]}
          onClickHandle={() => navigate(PATH_INFO.PAST_MEASUREMENTS.PATH)}
          iconSrc={paperIcon}
          iconHeight="21"
          iconWidth="21"
          isAuth={isAuth}
        />
        <BlackButton
          label="仕様書取り込み"
          subLabelParts={["指示寸法を入力", "(寸法を比較する)"]}
          subLabelBreakpointPx={DESKTOP_XMD_BREAKPOINT_PX}
          onClickHandle={() => navigate(PATH_INFO.SPECIFICATION_INPORT.PATH)}
          iconSrc={importIcon}
          iconHeight="21"
          iconWidth="21"
          isAuth={isAuth}
        />
      </div>
      <div className="flex space-x-[5px] desktop-xmd:space-x-[9px]">
        <BlackButton
          label={`採寸表${isSmall ? 'Download' : 'ダウンロード'}`}
          subLabelParts={["表示中の採寸表をpdfで", "ダウンロード"]}
          subLabelBreakpointPx={DESKTOP_XMD_BREAKPOINT_PX}
          onClickHandle={downloadPdf}
          iconSrc={downloadIcon}
          iconHeight="21"
          iconWidth="21"
          isAuth={isAuth}
        />
        <BlackButton
          label={`EC画像${isSmall ? 'Download' : 'ダウンロード'}`}
          subLabelParts={["撮影したEC画像のみを", "ダウンロード"]}
          subLabelBreakpointPx={DESKTOP_XMD_BREAKPOINT_PX}
          onClickHandle={() => { navigate(PATH_INFO.EC_PHOTO.PATH) }}
          iconSrc={ecImageDownloadIcon}
          iconHeight="21"
          iconWidth="21"
          isAuth={isAuth}
        />
      </div>
      <BlackButton
        label="過去の採寸表をダウンロード"
        subLabelParts={["過去に採寸した採寸表をダウンロード"]}
        onClickHandle={() => { navigate(PATH_INFO.SPECIFICATION_DOWNLOAD.PATH) }}
        iconSrc={pastMeasurementIcon}
        iconHeight="21"
        iconWidth="21"
        isAuth={isAuth}
      />
    </div>
  )
}